import { render } from "./RegisterContent.vue?vue&type=template&id=381fc01b"
import script from "./RegisterContent.vue?vue&type=script&lang=js"
export * from "./RegisterContent.vue?vue&type=script&lang=js"

import "./RegisterContent.vue?vue&type=style&index=0&id=381fc01b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__